import React from "react";
import { QRProps } from "@/contexts/QREditorContext/types";
import { PreviewUrlUnified } from "./PreviewUrlUnified";

/**
 * Wrapper de compatibilidad para PreviewUrl
 * Mantiene la API existente mientras usa la lógica unificada
 */
export default function PreviewUrl(props: QRProps<"url">) {
  return (
    <PreviewUrlUnified
      qrProps={props}
      page="url"
      dataQA="preview-url-container"
      translationKey="url"
    />
  );
}
